<template>
  <div class="question-index__wrapper text-center">
    <div v-if="questions >= current" class="question-index text-secondary-500 text-sm lg:text-base mb-2 lg:mb-8 block font-semibold">
      Frage {{ current }}/{{ questions }}
    </div>
  </div>
</template>

<script>
export default {

  props: {
    questions: Number,
    current: Number,
  },

  name: 'QuestionIndex',
}
</script>

<style scoped>

</style>
